import * as React from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { Link as RouterLink } from "react-router-dom";
import { ListItemIcon } from "@mui/material";
import ArrowForwardRoundedIcon from "@mui/icons-material/ArrowForwardRounded";
import { macrolinks } from "./macrolinks";

function ListItemLink(props) {
  const { primary, to, description } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef(function Link(itemProps, ref) {
        return <RouterLink to={to} ref={ref} {...itemProps} role={undefined} />;
      }),
    [to]
  );

  return (
    <Card>
      <CardContent>
        <li>
          <ListItemButton component={renderLink}>
            <ListItemText primary={primary} />
            <ListItemIcon>
              <ArrowForwardRoundedIcon />
            </ListItemIcon>
          </ListItemButton>
        </li>
        <Typography>
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
}

export default function MacrosNavigation() {
  return (
    <Box>
      <List dense={false}>
        <Grid container spacing={2}>
          {macrolinks.map((route) => {
            return (
              <Grid item xs={12} md={6} key={route.title}>
                <ListItemLink primary={route.title} to={`${route.route}`} description={route.description} />
              </Grid>
            );
          })}
        </Grid>
      </List>
    </Box>
  );
}
